import React from 'react';
import styles from './HomePageNavBarStyle.css';
//import flower from '../assets/flower3.svg';


const HomePageNavBar  = () => {
    return (

        <nav style={styles.navBar} className="navBar">        
            <nav>
            {/* <div className="flower">
                    <img href="/" src={flower} alt=""></img>
                </div> */}
                <ul>
                    
                {/* <li>
                    <img href="/" src={flower} className="flower" alt=""></img>
                </li> */}


                    <li>
                        <a href="/resume" alt="">Resume</a>
                    </li>

    

                    <li>
                        <a href="/Portfolio" alt="">Portfolio</a>
                    </li>

                

                    <li>
                        <a href="/Contact" alt=''>Contact</a>
                    </li>

                </ul>
            </nav>
        </nav>
    
    )
}


export default HomePageNavBar;
